import * as React from 'react';
import Login from './Login';

import { RootState } from '../store';
import { Dispatch, Action } from 'redux';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import Sidebar from './Sidebar';
import Gallery from './Gallery';
import Filter from './Filter';
import Disclaimer from './Disclaimer';
import Timeout from './Timeout';
import Checkout from './Checkout';
import Downloads from './Downloads';
import Thankyou from './Thankyou';

const mapStateToProps = (state: RootState) => ({
    show_menu: state.login.show_menu,
    show_disclaimer: state.login.show_disclaimer,
    show_timeout: state.login.show_timeout,
    show_checkout: state.login.show_checkout,
    show_download: state.login.show_download,
    show_thankyou: state.login.show_thankyou
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {}

class Main extends React.Component<Props, State> {


    public render() {
        if(this.props.show_menu) {
            return (
                <>
                <div style={{display: 'none'}} className="main-page-wrapper">

                    <Sidebar />
                </div>

                <Login />
                </>
            )
        }

        if(this.props.show_disclaimer) {
            return (
                <>
                <div style={{display: 'none'}} className="main-page-wrapper">

                    <Sidebar />
                </div>

                <Disclaimer />
                </>
            )
        }

        if(this.props.show_timeout) {
            return (
                <>
                <div style={{display: 'none'}} className="main-page-wrapper">

                    <Sidebar />
                </div>

                <Timeout />
                </>
            )
        }

        if(this.props.show_checkout) {

            return (
                <>
                <div style={{display: 'none'}} className="main-page-wrapper">

                    <Sidebar />
                </div>

                <Checkout />
                </>
            )

        }

        if(this.props.show_thankyou){
            return (
                <>
                <div style={{display: 'none'}} className="main-page-wrapper">

                    <Sidebar />
                </div>

                <Thankyou />
                </>
            )
        }

        if(this.props.show_download) {
            return (
                <div className="main-page-wrapper">

                <Sidebar />
                <Downloads />
                </div>
            )
        }

        return (
            <div className="main-page-wrapper">
                <Sidebar />
                <div className="full-width-container pt-90 pb-100">
                <Filter />
                <Gallery />
                </div>
            </div> 
        )

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Main);